// SEO Configuration for the application
export const seoConfig = {
  site: {
    name: 'Clube da 42',
    url: 'https://www.clubeda42.com.br',
    description: 'Clube de assinatura de cervejas artesanais da Cervejaria 42',
    logo: 'https://www.clubeda42.com.br/logo_42.jpg',
    defaultImage: 'https://www.clubeda42.com.br/logo_42.jpg',
  },
  social: {
    twitter: '@clubeda42',
    facebook: 'clubeda42',
    instagram: 'clubeda42',
  },
  organization: {
    name: 'Cervejaria 42',
    address: {
      streetAddress: 'Avenida 42',
      addressLocality: 'Brasil',
      addressCountry: 'BR',
    },
    contactPoint: {
      telephone: '+55-XX-XXXX-XXXX',
      contactType: 'customer service',
    },
  },
  defaultMeta: {
    title: 'Clube da 42 - Cervejas Artesanais por Assinatura',
    description:
      'Descubra cervejas artesanais únicas todo mês com o Clube da 42. Assinatura mensal de cervejas selecionadas da Avenida 42 e outras cervejarias independentes.',
    keywords: [
      'cerveja artesanal',
      'clube de cerveja',
      'assinatura cerveja',
      'cervejaria 42',
      'cervejas especiais',
      'clube da 42',
      'cerveja por assinatura',
      'cerveja artesanal por assinatura',
      'cerveja premium',
      'cervejaria independente',
    ],
  },
  pages: {
    home: {
      title: 'Clube da 42 - Cervejas Artesanais por Assinatura | Cervejaria 42',
      description:
        'Descubra cervejas artesanais únicas todo mês com o Clube da 42. Assinatura mensal de cervejas selecionadas da Avenida 42 e outras cervejarias independentes. Planos com e sem copo.',
      keywords:
        'cerveja artesanal, clube de cerveja, assinatura cerveja, cervejaria 42, cervejas especiais, clube da 42, cerveja por assinatura',
    },
    login: {
      title: 'Login - Clube da 42',
      description:
        'Faça login no Clube da 42 e acesse sua conta para gerenciar sua assinatura de cervejas artesanais.',
      keywords: 'login clube da 42, conta cervejaria 42, acesso assinatura',
    },
    signup: {
      title: 'Cadastre-se - Clube da 42',
      description:
        'Cadastre-se no Clube da 42 e comece sua jornada cervejeira com cervejas artesanais selecionadas.',
      keywords: 'cadastro clube da 42, nova conta, assinatura cerveja',
    },
  },
};

// Generate structured data for organization
export const getOrganizationStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'Organization',
  name: seoConfig.organization.name,
  description: seoConfig.site.description,
  url: seoConfig.site.url,
  logo: seoConfig.site.logo,
  address: {
    '@type': 'PostalAddress',
    ...seoConfig.organization.address,
  },
  contactPoint: {
    '@type': 'ContactPoint',
    ...seoConfig.organization.contactPoint,
  },
  sameAs: [
    `https://www.instagram.com/${seoConfig.social.instagram}`,
    `https://www.facebook.com/${seoConfig.social.facebook}`,
    `https://www.twitter.com/${seoConfig.social.twitter}`,
  ],
});

// Generate structured data for website
export const getWebsiteStructuredData = () => ({
  '@context': 'https://schema.org',
  '@type': 'WebSite',
  name: seoConfig.site.name,
  description: seoConfig.site.description,
  url: seoConfig.site.url,
  potentialAction: {
    '@type': 'SearchAction',
    target: {
      '@type': 'EntryPoint',
      urlTemplate: `${seoConfig.site.url}/search?q={search_term_string}`,
    },
    'query-input': 'required name=search_term_string',
  },
});

// Generate breadcrumb structured data
export const getBreadcrumbStructuredData = (
  items: Array<{ name: string; url: string }>,
) => ({
  '@context': 'https://schema.org',
  '@type': 'BreadcrumbList',
  itemListElement: items.map((item, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: item.name,
    item: item.url,
  })),
});
